import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TimezoneService {
  getClientTimezone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
